import { render, staticRenderFns } from "./PublicatorDialog.vue?vue&type=template&id=312d0c69&scoped=true"
import script from "./PublicatorDialog.vue?vue&type=script&lang=js"
export * from "./PublicatorDialog.vue?vue&type=script&lang=js"
import style0 from "./PublicatorDialog.vue?vue&type=style&index=0&id=312d0c69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312d0c69",
  null
  
)

export default component.exports